import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { CreateDataCrafterTemplate } from '../components';
import { DataCrafterTemplatesStores } from '../stores';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import {
    STORE_DATA_CRAFTER_TEMPLATES,
    STORE_DATA_CRAFTER_TEMPLATE_FORM,
    STORE_DATA_CRAFTER_OUTPUT_VARIANTS,
    STORE_DATA_CRAFTER_SCRIPT_COMPILATION
} from '../stores/constants';

const CreateDataCrafterTemplateScreen: React.FC<DataCrafterTemplatesStores> = ({
    dataCrafterTemplates,
    dataCrafterTemplateForm,
    dataCrafterOutputVariants,
    dataCrafterScriptCompilation
}) => {
    if (
        !dataCrafterTemplates ||
        !dataCrafterTemplateForm ||
        !dataCrafterOutputVariants ||
        !dataCrafterScriptCompilation
    ) {
        return null;
    }

    return (
        <HasPermission permissionClaim={AppPermissions.CanManageDataCrafterTemplates}>
            <CreateDataCrafterTemplate
                store={dataCrafterTemplates}
                createStore={dataCrafterTemplateForm}
                outputVariantsStore={dataCrafterOutputVariants}
                scriptCompilationStore={dataCrafterScriptCompilation}
            />
        </HasPermission>
    );
};

export default inject(
    STORE_DATA_CRAFTER_TEMPLATES,
    STORE_DATA_CRAFTER_TEMPLATE_FORM,
    STORE_DATA_CRAFTER_OUTPUT_VARIANTS,
    STORE_DATA_CRAFTER_SCRIPT_COMPILATION
)(observer(CreateDataCrafterTemplateScreen));
